import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { BiMinusCircle } from "react-icons/bi";
//date picker
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useMutation } from "@apollo/client";

import { AuthContext } from "../../Context/AuthContext";
import { SelectUser } from "../Include/DynamicSelect";
import ListReqTakeOut from "./ListReqTakeOut";
import { CHECK_TAKE_OUT_MATERIAL } from "../../Schema/TakeOut";
export default function CheckTakeOutMaterial({
  open,
  editData,
  handleClose,
  setRefetch,
  dialogTitle,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectOffice, setSelectedOffice] = useState({ id: "", title: "" });
  const [submitStutus, setSubmitStatus] = useState("");
  const [requireField, setRequireField] = useState(false);
  const [selectUser, setSelecteUser] = useState({
    _id: "",
    title: "",
    profileImage: "",
  });
  const listReqTakeOutMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    key: Date.now() + Math.random(),
  };
  const [listTakeOutData, setListTakeOutData] = useState([
    listReqTakeOutMaterial,
  ]);
  // console.log("submitStutus", submitStutus);
  const handleAddReqTakeOut = () => {
    setListTakeOutData([...listTakeOutData, listReqTakeOutMaterial]);
  };
  const handleUpdateReqTakeOut = (key, val, fieldName) => {
    const newListTakeOutData = listTakeOutData?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId")
          d.listMaterialUnitId = val;
        if (key === d.key && fieldName === "qty") d.qty = val;
      }
      return d;
    });
    setListTakeOutData(newListTakeOutData);
  };
  const handleDeleteListReqTakeOut = (key) => {
    const handleDeleteList = listTakeOutData?.filter((d) => d.key !== key);
    setListTakeOutData([...handleDeleteList]);
  };

  //checkTakeOutMaterial
  const [checkTakeOutMaterial] = useMutation(CHECK_TAKE_OUT_MATERIAL, {
    onCompleted: ({ checkTakeOutMaterial }) => {
      setLoading(false);
      if (checkTakeOutMaterial?.status) {
        setAlert(true, "success", checkTakeOutMaterial?.message);
        handleClose();
        resetForm();
        setRefetch();
        setListTakeOutData([listReqTakeOutMaterial]);
        setSelectedOffice({ id: "", title: "" });
      } else {
        setAlert(true, "error", checkTakeOutMaterial?.message);
        console.log("error");
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("error", error);
      setAlert(true, "error", error?.message);
    },
  });
  //formik
  const CheckValidation = Yup.object().shape({
    status: Yup.string().required("ទាមទារ!"),
    userId: Yup.string().required("ទាមទារ!"),
    remark: Yup.string(),
  });
  const formik = useFormik({
    initialValues: {
      status: "Pending",
      userId: "",
      remark: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("vlaues", values);
      let createStatus = false;
      const BreakException = {};
      try {
        listTakeOutData?.forEach(function (elem) {
          if (
            elem?.materialId?.id !== undefined &&
            elem?.materialId?.id !== "" &&
            elem?.listMaterialUnitId?.id !== undefined &&
            elem?.listMaterialUnitId?.id !== "" &&
            elem?.qty > 0
          ) {
            createStatus = true;
          } else {
            setLoading(false);
            setRequireField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      if (createStatus) {
        let listReqTakeOutMaterialToSubmit = listTakeOutData?.map((d) => {
          // console.log("d", d);
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: parseFloat(d?.qty),
          };
        });
        setLoading(true);
        checkTakeOutMaterial({
          variables: {
            id: editData?._id,
            status: submitStutus === "Approved" ? "Approved" : "Rejected",
            userId: values?.userId,
            checkTakeOutMaterial:
              submitStutus === "Approved" ? listReqTakeOutMaterialToSubmit : [],
            remark: values?.remark,
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("remark", editData?.remark ?? "");
      setSelecteUser({
        _id: editData?.userId?._id,
        title: editData?.userId?.mainUserId?.firstName + ' ' +editData?.userId?.mainUserId?.lastName,
        profileImage: editData?.userId?.userId?.officeKhName,
      });
      setFieldValue("userId", editData?.userId?._id);
    }

    if (editData?.reqTakeOutMaterial?.length !== 0) {
      const dataFromBackend = editData?.reqTakeOutMaterial?.map((d) => {
        return {
          key: Date.now() + Math.random(),
          materialId: {
            id: d?.listMaterialUnitId?.materialId?._id,
            title: d?.listMaterialUnitId?.materialId?.materialEnName,
          },
          listMaterialUnitId: {
            id: d?.listMaterialUnitId?._id,
            title: d?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: d?.listMaterialUnitId?.imageSrc,
          },
          qty: d?.qty,
        };
      });
      // console.log("dataFromBackend::", dataFromBackend)
      setListTakeOutData([...dataFromBackend]);
    }
  }, [editData, open]);

  // useEffect(() => {
  //   if (selectOffice?.id) {
  //     setFieldValue("userId", selectOffice?.id ?? "");
  //   }
  // }, [selectOffice?.id]);
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              បង្កើតសំណើរផ្ទេរចេញ
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">
                  អ្នកតំណាងការិយាល័យ
                </Typography>
                {/* <SelectOffice
                  selectedVal={selectOffice}
                  setSelectedVal={setSelectedOffice}
                />
                {!!errors.userId && touched.userId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.userId}
                  </FormHelperText>
                )} */}
                <SelectUser
                  selectedVal={selectUser}
                  setSelectedVal={setSelecteUser}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <Grid item xs={12}>
                <ListReqTakeOut
                  handleDeleteList={handleDeleteListReqTakeOut}
                  handleUpdateList={handleUpdateReqTakeOut}
                  handleAddList={handleAddReqTakeOut}
                  requiredField={requireField}
                  listTakeOutData={listTakeOutData}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={6}>
                {loading ? (
                  <Button className="btn-delete" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-delete"
                    fullWidth
                    onClick={() => {
                      setSubmitStatus("Rejected");
                      handleSubmit();
                    }}
                  >
                    បដិសេធ
                  </Button>
                )}
              </Grid>
              <Grid item xs={6}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={() => {
                      setSubmitStatus("Approved");
                      handleSubmit();
                    }}
                  >
                    អនុម័ត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
